<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-12-21 19:02:18
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-03-30 18:30:15
-->
<template>
  <div class="innovative innovative-accuffrct" :class="{textj: language != 'en'}" ref="accuffrct">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/m/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.accuffrct.title')"></div>
    </div>
    <div class="p-t-50 p-b-10">
      <div class="p-l-30 p-r-30">
        <div class="innovative-item-title p-l-25" v-html="$t('product.accuffrct.list[0].title')"></div>
      </div>
      <div class="p-t-28 p-l-30 p-r-15">
        <img class="wid100" :src="$t('product.accuffrct.list[0].img')" alt="" srcset="">
      </div>
      <div class="p-l-30 p-r-30 textj">
        <p class="p-t-20 p-b-20" v-for="item, index in $t('product.accuffrct.list[0].des')" :key="index" v-html="item"></p>
      </div>
    </div>
    <div>
      <div class="accuffrct-characteristics">
        <div class="innovative-container">
          <div class="innovative-item-title" v-html="$t('product.accuffrct.list[1].title')"></div>
          <div class="accuffrct-characteristics-box">
            <div class="p-t-20 p-b-20" v-for="item, index in $t('product.accuffrct.list[1].des')" :key="index">
              <div class="textc p-b-15">
                <img class="accuffrct-characteristics-img" :src="item.img" alt="" srcset="">
              </div>
              <div class="innovative-wrap-item-title textc fz-30 p-b-25">
                <p v-for="$item, $index in item.title" :key="$index" v-html="$item"></p>
              </div>
              <div>
                <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="accuffrct-advantages">
      <div class="innovative-item-title" v-html="$t('product.accuffrct.list[2].title')"></div>
      <div class="innovative-accuffrct-m-h p-t-50">
        <div class="innovative-accuffrct-m-h-item" :class="{flex: language != 'en'}" v-for="item, index in $t('product.accuffrct.list[2].des')" :key="index">
          <div class="p-r-30 textc">
            <img class="accuffrct-characteristics-img" :src="item.img" alt="" srcset="">
            <div class="innovative-wrap-item-title fz-28 p-t-20" v-html="item.title"></div>
          </div>
          <div class="flex_1 p-t-10">
            <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="innovative-container">
      <div class="p-t-20 article">
        <div class="innovative-item-title" v-html="$t('product.accuffrct.article.title')"></div>
        <div class="p-t-15">
          <p class="p-t-15" v-for="item, index in $t('product.accuffrct.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>

<style lang="less">
@import "~@/styles/m/products.less";
</style>

<style lang="less" scoped>
.m .innovative-accuffrct {
  .accuffrct-characteristics {
    background-image: url('~@/assets/images/innovate/AccuFFRct/m_2.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: top;
    padding: 20px 0;
    .accuffrct-characteristics-box {
      background: #FFFFFF;
      box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
      padding: 50px;
    }
    .accuffrct-characteristics-img {
      max-height: 65px;
    }
  }
  .accuffrct-advantages {
    background: #F8FBFF;
    border-radius: 8px;
    padding: 50px 30px;
  }
  .innovative-accuffrct-m-h {
    background: #FFFFFF;
    box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
    padding: 30px;
    .innovative-accuffrct-m-h-item {
      padding: 20px;
    }
    img {
      max-width: 100px;
    }
  }
}
</style>
